var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.clearfilters}},[_vm._v("Clear All Filters")])
}
var staticRenderFns = []

export { render, staticRenderFns }